import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import KtoClubMobile from './../../../images/kto_club_mobile_link.svg'

export const StyledBackgroundAnimationWrapper = styled.div`
  width: 200vw;
  height: 100%;
  position: fixed;
  overflow-x: hidden;
  top: 0;
  left: 0;
  z-index: 3020; //has to be higher than bottom navigation
  flex-direction: column;
  display: flex;

  ${(props) =>
    props.isShown ?
      css`
          pointer-events: auto;
          transition: 0.3s ease-out;
          transform: translateX(0vw);
          background-color: rgba(0, 0, 0, 0.5);
          opacity: 1;
        ` :
      css`
          pointer-events: none;
          transition: 0.6s ease-in;
          transform: translateX(-50%);
          opacity: 0;
        `}
`

export const StyledContentWrapper = styled.div`
  height: calc(100% - 90px);
  overflow-y: auto;
  &.gamification-disabled {
    height: 100%;
    padding-bottom: 20px;
  }
`

export const StyledMenuItemsWrapper = styled.div`
  padding: 0 1rem;
  padding-top: ${({ paddingTop }) => `${paddingTop}px`};

  > img {
    &.logo {
      text-align: center;
      margin: 2.5rem 0 2rem 0;
    }
  }
  .clube-kto {
    display: block;
  }
`

export const StyledRow = styled.div`
  display: flex;
  gap: 20px;
  margin: 0 0 2rem 0;

  button.cta {
    width: 100%;
  }

  > a,
  > button {
    flex: 0 1 50%;
    line-height: 20px;

    @supports (-webkit-touch-callout: none) and (not (translate: none)) {
      &:not(:last-child) {
        margin-right: 5%;
      }
    }
  }
`

export const StyledCol = styled.div`
  display: flex;
  flex-flow: column;
  margin: 2rem 0 0 0;

  .nav-link-row {
    height: 35px;

    img {
      height: 24px;

      &.mobile {
        display: block;
      }
    }

    a {
      text-align: left;
      line-height: 24px;

      &.active {
        border-bottom: none;
      }
    }
  }
`

export const StyledContentAnimationWrapper = styled.div`
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
  width: 320px;
  max-width: 90vw;
  height: 100%;
  transition: all 0.5s ease;
  animation: slide-out 0.5s forwards;
  transform: translateX(-100%);
  text-align: center;
  position: relative;

  ${(props) =>
    props.isShown ?
      css`
          transform: translateX(0%);
          animation: slide-in 0.5s forwards;
        ` :
      ''};

  a.cashback {
    text-align: left;
    border: none;
    padding: 0 0 0 33px;
    background-position-x: 3px;
    background-size: 19px;
    background-color: unset;
    line-height: 30px;
  }

  .clube-kto { 
    position: absolute;
    bottom: 0;
    left: 0;
    width: 272px;
    height: 50px;
    left: 24px;
    bottom: 20px;
    background: url(${KtoClubMobile})
  }

  div {
    box-sizing: border-box;
  }
`